module.exports = __webpack_public_path__ + "img/max-file-repeat.82c44423.svg";